import { useQuery } from "@tanstack/react-query";
import axios from "axios";

// Full trainer records (/trainers, ~330 KB) - distinct from useTrainers, which
// reads the small /trainers/summary. The /courses page used to fetch this
// endpoint twice (SidebarRight and InstructorProfile each had their own axios
// call); sharing one query key lets both read a single request.
export const useAllTrainers = () => {
  return useQuery({
    queryKey: ["trainers", "all"],
    queryFn: async () => {
      const res = await axios.get(`https://api.hachion.co/trainers`);
      return Array.isArray(res.data) ? res.data : [];
    },
    staleTime: 1000 * 60 * 5,
    refetchOnWindowFocus: false,
    retry: 1,
  });
};
